/**
 * Ruta `/marcaciones` (T077): marcaciones de la empresa, con su detalle.
 *
 * `validateSearch` acepta `marca` (id de marca, `mrk_<ULID>`, `@fermin/contracts`) en la query
 * (`/marcaciones?marca=…`: el enlace de un evento de auditoría sobre una marca y el de "Últimas
 * marcaciones" del dashboard). Lo que no encaje con el formato se descarta, igual que
 * `marcadores.tsx`: la pantalla arranca sin el drawer abierto en vez de romperse con una URL
 * manipulada. Una marca bien formada pero inexistente o de otra empresa sí abre el drawer: la API
 * responde `404`, indistinguible de un id inventado (FR-022), y el drawer muestra su "no
 * encontrado".
 *
 * `onMarkChange` (de `marks-page.tsx`) mantiene `marca` sincronizado con lo que el drawer muestra:
 * abrir o navegar la cadena de correcciones lo fija, cerrar el drawer lo quita. Siempre con
 * `replace`, para no ensuciar el historial con cada marca que el admin mira.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { AttendanceMarkId } from '@fermin/contracts';

import { MarksPage } from '../../features/attendance/marks-page';

export interface MarksSearch {
  marca?: string;
}

export const Route = createFileRoute('/_app/marcaciones')({
  validateSearch: (search: Record<string, unknown>): MarksSearch => {
    const marca = AttendanceMarkId.safeParse(search['marca']);
    return marca.success ? { marca: marca.data } : {};
  },
  component: function MarcacionesRoute() {
    const { marca } = Route.useSearch();
    const navigate = useNavigate({ from: Route.fullPath });
    return (
      <MarksPage
        markId={marca ?? null}
        onMarkChange={(markId) =>
          void navigate({
            search: (prev) => ({ ...prev, marca: markId ?? undefined }),
            replace: true,
          })
        }
      />
    );
  },
});
